module.exports = __webpack_public_path__ + "img/default-category.98f924ea.png";